import React from 'react'

const BookIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M6.25 18.3333C5.44445 18.3333 4.75695 18.0486 4.1875 17.4792C3.61806 16.9097 3.33334 16.2222 3.33334 15.4167V4.58332C3.33334 3.77777 3.61806 3.09027 4.1875 2.52082C4.75695 1.95138 5.44445 1.66666 6.25 1.66666H16.6667V14.1667C16.3194 14.1667 16.0243 14.2882 15.7813 14.5312C15.5382 14.7743 15.4167 15.0694 15.4167 15.4167C15.4167 15.7639 15.5382 16.059 15.7813 16.3021C16.0243 16.5451 16.3194 16.6667 16.6667 16.6667V18.3333H6.25ZM6.66667 12.5H8.33334V3.33332H6.66667V12.5ZM6.25 16.6667H14.0208C13.9375 16.4722 13.8715 16.2743 13.8229 16.0729C13.7743 15.8715 13.75 15.6528 13.75 15.4167C13.75 15.1944 13.7708 14.9792 13.8125 14.7708C13.8542 14.5625 13.9236 14.3611 14.0208 14.1667H6.25C5.88889 14.1667 5.59028 14.2882 5.35417 14.5312C5.11806 14.7743 5 15.0694 5 15.4167C5 15.7778 5.11806 16.0764 5.35417 16.3125C5.59028 16.5486 5.88889 16.6667 6.25 16.6667Z"
        fill="#FF5612"
      />
    </svg>

  )
}

export default BookIcon